import { z } from 'zod';
/**
 * Theme / Mood（Phase D 設計書 §4.2）
 *
 * mood は「場面の空気」を表す層2の語彙。Player 側で `<html data-mood="...">` に流すと、
 * Foundation の CSS variables（--mg-bg / --mg-accent 等）が mood ごとに切り替わる。
 *
 * 設計上の不変条件:
 * - 明示指定（step `bg` / `routeMap` / ミニゲーム背景）が最優先。mood トークンは未指定時の既定値。
 * - `theme` は全レイヤで optional。`theme` 無しの既存シナリオは従来通り描画される。
 */
/**
 * mood は 7 種（stillness/tension/mystic/melancholy/dread/playful/comedic）。
 * 追加は将来可・削除/改名は Phase B 凍結後に破壊的変更となる。
 * コードは英語 enum、和訳ラベルは下の MOOD_LABELS_JA で別管理する。
 */
export const MoodSchema = z.enum([
    'stillness', // 静謐（水辺・夜・抑制された感情）
    'tension', // 緊迫（追跡・QTE・時間制限）
    'mystic', // 神秘（超常・異界・覚醒）
    'melancholy', // 哀愁（失われたもの・記憶）
    'dread', // 恐怖（ホラー系テンプレ向け）
    'playful', // 軽妙（楽しい・軽快な場面向け）
    'comedic', // コミカル（ネタ・コメディ・ドタバタ）
]);
/**
 * UI 表示用の和訳ラベル。enum を直接画面に出さないため別マッピングで保持する
 * （将来の Mood Vocabulary 表・Studio の mood 編集 UI で使う）。
 */
export const MOOD_LABELS_JA = {
    stillness: '静謐',
    tension: '緊迫',
    mystic: '神秘',
    melancholy: '哀愁',
    dread: '恐怖',
    playful: '軽妙',
    comedic: 'コミカル',
};
/**
 * Theme スキーマ。
 * - mood.primary: 必須。場面全体の基調。
 * - mood.tension: 任意。緊張時に上乗せする mood。
 * - mood.warmth: 任意。色温度の微調整用 mood。
 * - palette / font / bgmTone: mood を直接上書きしたい時の escape hatch（任意）。
 */
export const ThemeSchema = z.object({
    mood: z.object({
        primary: MoodSchema,
        tension: MoodSchema.optional(),
        warmth: MoodSchema.optional(),
    }),
    /** mood トークンを直接上書きするカラー（escape hatch）。token名→hex 等。 */
    palette: z.record(z.string()).optional(),
    /** フォント指定（用途名→font-family 等）。 */
    font: z.record(z.string()).optional(),
    /** BGM トーン指定（用途名→値）。 */
    bgmTone: z.record(z.string()).optional(),
});
//# sourceMappingURL=theme.js.map